var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierarchy3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6665 6.4165C8.76701 6.4165 6.4165 8.76701 6.4165 11.6665C6.4165 14.566 8.76701 16.9165 11.6665 16.9165C14.566 16.9165 16.9165 14.566 16.9165 11.6665C16.9165 8.76701 14.566 6.4165 11.6665 6.4165ZM2.9165 11.6665C2.9165 6.83401 6.83401 2.9165 11.6665 2.9165C16.499 2.9165 20.4165 6.83401 20.4165 11.6665C20.4165 16.499 16.499 20.4165 11.6665 20.4165C6.83401 20.4165 2.9165 16.499 2.9165 11.6665Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.333 22.75C41.4335 22.75 39.083 25.1005 39.083 28C39.083 30.8995 41.4335 33.25 44.333 33.25C47.2325 33.25 49.583 30.8995 49.583 28C49.583 25.1005 47.2325 22.75 44.333 22.75ZM35.583 28C35.583 23.1675 39.5005 19.25 44.333 19.25C49.1655 19.25 53.083 23.1675 53.083 28C53.083 32.8325 49.1655 36.75 44.333 36.75C39.5005 36.75 35.583 32.8325 35.583 28Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6665 39.083C8.76701 39.083 6.4165 41.4335 6.4165 44.333C6.4165 47.2325 8.76701 49.583 11.6665 49.583C14.566 49.583 16.9165 47.2325 16.9165 44.333C16.9165 41.4335 14.566 39.083 11.6665 39.083ZM2.9165 44.333C2.9165 39.5005 6.83401 35.583 11.6665 35.583C16.499 35.583 20.4165 39.5005 20.4165 44.333C20.4165 49.1655 16.499 53.083 11.6665 53.083C6.83401 53.083 2.9165 49.1655 2.9165 44.333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6665 16.9165C12.633 16.9165 13.4165 17.7 13.4165 18.6665C13.4165 21.8052 14.3442 23.5925 15.5508 24.6327C16.8058 25.7146 18.6631 26.2498 20.9998 26.2498H37.3332C38.2997 26.2498 39.0832 27.0333 39.0832 27.9998C39.0832 28.9663 38.2997 29.7498 37.3332 29.7498H20.9998C18.2689 29.7498 15.5257 29.1477 13.4165 27.4108V37.3332C13.4165 38.2997 12.633 39.0832 11.6665 39.0832C10.7 39.0832 9.9165 38.2997 9.9165 37.3332V18.6665C9.9165 17.7 10.7 16.9165 11.6665 16.9165Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchy3);
export default __webpack_public_path__ + "static/media/hierarchy-3.c4f8208e72a7d111fc9132f338d2c3f3.svg";
export { ForwardRef as ReactComponent };